import { isFeatureFlagEnabled } from '@doordash/lib-feature-flags'
import { AUS_NCC_BGC } from '../../../../../../experimentConstants'

export function isPlatformWorkflowStep() {
  return isFeatureFlagEnabled(AUS_NCC_BGC)
}
